import { collection, doc, getFirestore, onSnapshot, setDoc } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { app } from '../../util/firebase';
import {Routes,Route, Link} from 'react-router-dom';
import UpdatePharmacie from './UpdatePharmacie';

const ListPharmacies = (props) => {
    
    const [listPharmacies, setListPharmacies ] = useState([])
    const [pharmID, setPharmID ] = useState("")

    useEffect(()=>{
        onSnapshot(collection(getFirestore(app),"users"),(snap)=>{
            setListPharmacies(snap.docs.map((snap)=> {
                let user = snap.data()
                user.id = snap.id
                return user
            }))
        })
    },[])

    const recoverArchived=(pharm)=>{
        pharm.isArchived = false
        setDoc(doc(getFirestore(app),"users",pharm.id),pharm)
        .then((res)=> alert('La pharmacie a bien été récupèrée'))
        .catch(err=>alert(err))
    }
    const allPharmacies = ()=>{
        let list = listPharmacies.filter(user=> user.status === 'pharmacie' && user.isArchived === props.isArchived)
        return list.map((pharm,index)=>{
            return(
                <tr key={index}>
                    <td><img style={{maxHeight:'40px'}} className="product-img" src={pharm.imgSrc}  alt="" /></td>
                    <td>{pharm.userName}</td>
                    <td>{pharm.adresse}</td>
                    <td>{pharm.email}</td>
                    
                    {
                        props.isArchived?
                        <td >
                            <button className="btn btn-warning" onClick={e=>recoverArchived(pharm)}>Recupérer</button>
                        </td>
                        :
                        <td>
                            <Link to="updatePharmacie">
                                <button className="btn btn-primary" onClick={e=>setPharmID(pharm.id)}>Modifier</button>
                            </Link>
                        </td>
                    }
                </tr>
            )
        })
    }

    return (
        <div>
            <Routes>
                <Route path='' element={
                    <div className="col-12 bg-light p-3">
                        <table className="table table-striped table-hover border rounded">
                            <thead>
                                <tr className='bg-white '>
                                    <td>Image </td>
                                    <td>Nom Complet </td>
                                    <td>Adresse </td>
                                    <td>Email </td>
                                    <td>Action </td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    allPharmacies()
                                }
                            </tbody>
                        </table>
                    </div>
           
                }></Route>
                <Route path='updatePharmacie' element={<UpdatePharmacie pharmID = {pharmID}/>}></Route>
            </Routes>
        </div>
    );
};

export default ListPharmacies;